import React, { useRef } from "react";
import { Box, Typography, Modal, Fade, Grid, Button } from "@mui/material";
import { CloseRounded as CloseRoundedIcon } from "@mui/icons-material";
import StyleVariables from "../../assets/styles/Variable.module.scss";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onBackToSouvenirs: () => void;
  onContinue: () => void;
}

const SouvenirSelectionWarning = (props: Props) => {
  const actionRef = useRef<"back" | "continue" | null>(null);

  const onClose = () => {
    actionRef.current = null;
    props.onClose();
  };

  const onBackToSouvenirs = () => {
    actionRef.current = "back";
    props.onClose();
  };

  const onContinue = () => {
    actionRef.current = "continue";
    props.onClose();
  };

  const onExited = () => {
    const action = actionRef.current;
    actionRef.current = null;

    // Wait for the modal to close and restore focus.
    requestAnimationFrame(() => {
      if (action === "back") {
        props.onBackToSouvenirs();
      } else if (action === "continue") {
        props.onContinue();
      }
    });
  };

  return (
    <Modal
      className="modal modal-md"
      open={props.isOpen}
      onClose={onClose}
      closeAfterTransition
      aria-labelledby="souvenir-selection-warning-title"
      aria-describedby="souvenir-selection-warning-description"
    >
      <Fade in={props.isOpen} onExited={onExited}>
        <Box className="modal-body">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            borderBottom={`1px solid ${StyleVariables["color-border"]}`}
            paddingBottom={2}
          >
            <Typography
              id="souvenir-selection-warning-title"
              variant="h6"
              fontWeight={"bold"}
              color={StyleVariables["color-header"]}
            >
              กรุณาตรวจสอบรายการของแถม
            </Typography>
            <CloseRoundedIcon
              onClick={onClose}
              sx={{
                color: StyleVariables["color-main-icon"],
                fontSize: 32,
                cursor: "pointer",
              }}
            />
          </Box>
          <Box marginY={5} textAlign={"center"}>
            <Typography
              id="souvenir-selection-warning-description"
              variant="body2"
              fontWeight={"regular"}
              color={StyleVariables["color-text"]}
            >
              รายการนี้สามารถเลือกของแถมได้ ของแถมบางรายการอาจหมดหรือไม่สามารถเลือกได้ โปรดตรวจสอบรายการของแถมก่อนดำเนินการต่อ
            </Typography>
          </Box>
          <Grid
            container
            spacing={2}
            flexDirection={{ xs: "column-reverse", md: "row" }}
          >
            <Grid item xs={12} md={6}>
              <Button
                variant="outlined"
                fullWidth
                onClick={onContinue}
              >
                ดำเนินการต่อ (ไม่แถม)
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                variant="contained"
                fullWidth
                onClick={onBackToSouvenirs}
              >
                กลับไปเลือกของแถม
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SouvenirSelectionWarning;